import { render, staticRenderFns } from "./ErrorServices.vue?vue&type=template&id=498cbcce&scoped=true&"
import script from "./ErrorServices.vue?vue&type=script&lang=js&"
export * from "./ErrorServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498cbcce",
  null
  
)

export default component.exports